import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { QueryKey } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';

const useDisableHostfullyAccountingModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { disableIntegration } = useDisableIntegrationMutation();

  const openDisableHostfullyAccountingModal = ({
    integrationEnumId,
    queryKey,
  }: {
    integrationEnumId: IntegrationEnum;
    queryKey: QueryKey;
  }) => {
    const handleConfirmDisable = async () => {
      await disableIntegration({
        level: IntegrationMutationLevel.AGENCY,
        enumId: integrationEnumId,
        queryKey,
      });
    };

    openConfirmModal({
      title: t('pageIntegrations.modals.disableHostfullyAccounting.title'),
      body: (
        <Alert bsStyle="danger">
          <div>
            {t('pageIntegrations.modals.disableHostfullyAccounting.question')}
          </div>
          <div>
            {t(
              'pageIntegrations.modals.disableHostfullyAccounting.consequences',
            )}
          </div>
        </Alert>
      ),
      confirmLabel: t(
        'pageIntegrations.modals.disableHostfullyAccounting.confirmBtn',
      ),
      cancelLabel: t('common.cancel'),
      confirmColor: 'danger',
      onConfirmAsync: handleConfirmDisable,
    });
  };

  return { openDisableHostfullyAccountingModal };
};

export default useDisableHostfullyAccountingModal;
